<template>
  <div id="maint" ref="maint" style="width: 100%; height: 100%"></div>
</template>
<script>
import { initResizeListener } from '@/utils/utils';

export default {
  data() {
    return {
      myChartt: null,
    };
  },
  props: {
    source: Object,
  },
  watch: {
    source(a) {
      if (a === null) {
        this.myChartt.clear();
      } else {
        this.$nextTick(this.initData);
      }
    },
    skinType() {
      this.initData();
    },
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    // 初始化数据
    initData() {
      // 基于准备好的dom，初始化echarts实例
      if (this.myChartt === null) {
        this.myChartt = this.$echarts.init(this.$refs.maint);
        initResizeListener(this.myChartt, this.$refs.maint);
      } else {
        this.myChartt.clear();
      }
      // 绘制图表
      this.myChartt.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            label: {
              show: true,
            },
          },
        },

        calculable: true,
        legend: {
          data: ['上月', '本月'],
          itemGap: 5,
          top: '5%',
          textStyle: {
            color: 'auto',
          },
        },
        grid: {
          top: '36',
          left: '20',
          right: '20',
          bottom: '30',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: this.source.xAxisData,
            axisLabel: {
              color: 'auto',
            },
            axisLine: {
              color: 'auto',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: 'kWh',
            nameTextStyle: {
              color: this.skinType ? '#fff' : '#333',
            },
            axisLabel: {
              formatter: (a) => (Number.isFinite(a) ? this.$echarts.format.addCommas(a.toString()) : ''),
              color: this.skinType ? '#fff' : '#333',
            },
            axisLine: {
              color: this.skinType ? '#fff' : '#333',
            },
            splitLine: {
              lineStyle: {
                color: '#ccc',
                type: 'dashed',
              },
            },
          },
        ],
        dataZoom: [
          {
            show: true,
            height: 10, // 组件高度
            start: 0,
            end: 100,
            bottom: 20, // 右边的距离
            fillerColor: 'rgba(0, 0, 0, 0);',
          },
        ],
        series: [
          {
            name: '上月',
            type: 'bar',
            data: this.source.seriesData[0].Data,
          },
          {
            name: '本月',
            type: 'bar',
            data: this.source.seriesData[1].Data,
          },
        ],
        color: [
          '#FFAF8E',
          '#667EEB',
          '#75B2FB',
          '#08BED3',
          '#F67CA3',
          '#7FC4C2',
          '#7a81b5'],
      });
    },
  },
};
</script>
